@if (!isLoading) {
    <div class="row table-header fw-bold p-2 mt-2">
        <div class="col-6 col-lg-2 offset-1">
            <span translate="NOTIFICATION_HISTORY_DETAIL_NOTIFICATION_NUMBER_HEADER"></span>
        </div>
        <div class="col-lg-3 col-5">
            <span translate="NOTIFICATION_HISTORY_DETAIL_NOTIFICATION_SYSTEM_HEADER"></span>
        </div>
        <div class="col-3 d-lg-block d-none">
            <span translate="NOTIFICATION_HISTORY_DETAIL_NOTIFICATION_CUSTOMER_NAME_HEADER"></span>
        </div>
        <div class="col d-lg-block d-none">
            <span translate="NOTIFICATION_HISTORY_DETAIL_NOTIFICATION_CRM_DATE_HEADER"></span>
        </div>
    </div>
}
<ng-container *ngrxLet="notificationsHistory$ as notificationHistory">
    @for (
        notificationHistoryEntry of notificationHistory | keyvalue;
        track trackByKey($index, notificationHistoryEntry)
    ) {
        <div>
            <pace-docbox-notification-history-detail
                [notifications]="notificationHistoryEntry.value"
                (refresh)="refreshData()"
            ></pace-docbox-notification-history-detail>
        </div>
    }
</ng-container>
@if (!isLoading) {
    <div class="d-flex justify-content-end">
        <button
            class="btn btn-primary"
            (click)="refreshData()"
            translate="DASHBOARD_DOCBOX_TABBED_MODAL_RELOAD_BUTTON_LABEL"
        ></button>
    </div>
}
@if (isLoading) {
    <progressbar [striped]="true" [value]="100" type="default">
        <span translate="NOTIFICATION_HISTORY_LOADING"></span>
    </progressbar>
}
